import { render, staticRenderFns } from "./GroupTrainingsPage.vue?vue&type=template&id=1cea0fcc&scoped=true&"
import script from "./GroupTrainingsPage.vue?vue&type=script&lang=ts&"
export * from "./GroupTrainingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea0fcc",
  null
  
)

export default component.exports